import { ApolloLink } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';

import { configService } from '@bluecodecom/digital-goods-webview/features/config';

const authHttpLink = new HttpLink({
  uri: `https://digital-goods-api.${configService.domain}/auth/graphql`,
});

const clientHttpLink = new HttpLink({
  uri: `https://digital-goods-api.${configService.domain}/client/graphql`,
});

const publicHttpLink = new HttpLink({
  uri: `https://digital-goods-api.${configService.domain}/public/graphql`,
});

export default ApolloLink.split(
  ({ operationName }) => operationName?.startsWith('Public') || false,
  publicHttpLink,
  ApolloLink.split(
    ({ operationName }) => operationName?.startsWith('Auth') || false,
    authHttpLink,
    clientHttpLink,
  ),
);
